export const nav: any = {};

nav.getSiteContext = (history) => {
	// ADD TO COMPONENT const history = useHistory();
	const context = history.location.pathname.split("/")[1];
	return context;
};

nav.hidePrimary = (state) => {
	state.primaryNav.classList.add("hideSection");
};

nav.hideSecondary = (state) => {
	state.secondaryNav.classList.add("hideSection");
};

nav.showPds = (state) => {
	state.pdsFooter?.classList.remove("hideSection");
	state.primaryFooter?.classList.add("hideSection");
};

nav.reset = (state) => {
	state.primaryNav.classList.remove("hideSection");
	state.secondaryNav.classList.remove("hideSection");
	state.primaryFooter.classList.remove("hideSection");
	state.pdsFooter.classList.add("hideSection");
};

export default nav;
